import { motion } from "framer-motion";
import { Phone, Mail, MapPin, Instagram, Facebook, Music2 } from "lucide-react";
import Logo from "../components/Logo";
import { scrollToHash } from "./Nav";

const ease = [0.22, 1, 0.36, 1];

const CARDS = [
  { icon: Phone, label: "Call or text", value: "07709 111060", href: "tel:07709111060", testid: "contact-phone-link" },
  { icon: Mail, label: "Email", value: "info.velvetbakes@gmail.com", href: "mailto:info.velvetbakes@gmail.com", testid: "contact-email-link" },
  { icon: MapPin, label: "The studio", value: "By appointment only", href: null, testid: "contact-location" },
  { icon: Instagram, label: "Instagram", value: "@Velvetbakes.London", href: "https://instagram.com/Velvetbakes.London", testid: "contact-instagram-link" },
  { icon: Facebook, label: "Facebook", value: "Velvet Bakes", href: null, testid: "contact-facebook" },
  { icon: Music2, label: "TikTok", value: "@Misskaur_ox", href: "https://www.tiktok.com/@Misskaur_ox", testid: "contact-tiktok-link" },
];

const Contact = () => (
  <section id="contact" className="relative bg-[#2E1E26] text-[#F9F6F0] pt-24 md:pt-32 pb-12 overflow-hidden" data-testid="contact-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease }}
        className="text-center mb-16"
      >
        <p className="text-xs uppercase tracking-[0.3em] font-semibold text-[#C5A059] mb-4">Say Hello</p>
        <h2 className="font-serif text-4xl md:text-6xl font-light leading-tight">
          Let's bake something <span className="italic text-[#B87D8E]">beautiful</span> together
        </h2>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.8, ease }}
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-20"
        data-testid="contact-cards"
      >
        {CARDS.map((card, i) => {
          const inner = (
            <>
              <card.icon size={22} className="text-[#C5A059]" />
              <p className="mt-5 text-xs uppercase tracking-[0.25em] text-[#F9F6F0]/50">{card.label}</p>
              <p className="mt-2 font-serif text-xl md:text-2xl text-[#F9F6F0] break-all">{card.value}</p>
            </>
          );
          const cls =
            "block border border-[#B87D8E]/20 rounded-3xl p-7 bg-[#F9F6F0]/[0.03] hover:border-[#C5A059]/60 hover:bg-[#F9F6F0]/[0.06] transition-all duration-500";
          return (
            <motion.div
              key={card.label}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.08, ease }}
            >
              {card.href ? (
                <a href={card.href} data-testid={card.testid} className={cls} target={card.href.startsWith("http") ? "_blank" : undefined} rel="noreferrer">
                  {inner}
                </a>
              ) : (
                <div data-testid={card.testid} className={cls}>{inner}</div>
              )}
            </motion.div>
          );
        })}
      </motion.div>

      <div className="border-t border-[#B87D8E]/15 pt-10 flex flex-col md:flex-row items-center justify-between gap-8">
        <Logo dark />
        <nav className="flex flex-wrap justify-center gap-x-8 gap-y-3 text-sm text-[#F9F6F0]/60">
          {[
            ["Our Bakes", "#gallery", "footer-gallery-link"],
            ["Pricing", "#pricing", "footer-pricing-link"],
            ["Policies", "#policies", "footer-policies-link"],
            ["Order", "#order", "footer-order-link"],
            ["About", "#about", "footer-about-link"],
          ].map(([label, href, testid]) => (
            <a
              key={href}
              href={href}
              data-testid={testid}
              onClick={(e) => { e.preventDefault(); scrollToHash(href); }}
              className="hover:text-[#C5A059] transition-colors duration-300"
            >
              {label}
            </a>
          ))}
        </nav>
        <p className="text-xs text-[#F9F6F0]/40">© {new Date().getFullYear()} Velvet Bakes · Sweet moments, beautifully baked.</p>
      </div>
    </div>
  </section>
);

export default Contact;
